module.exports = __webpack_public_path__ + "img/cloud-bottom-right.4ffc4aa6.svg";